/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrintTextResponse
 */
export interface PrintTextResponse {
    /**
     * 
     * @type {string}
     * @memberof PrintTextResponse
     */
    serviceId: string;
}

/**
 * Check if a given object implements the PrintTextResponse interface.
 */
export function instanceOfPrintTextResponse(value: object): value is PrintTextResponse {
    if (!('serviceId' in value) || value['serviceId'] === undefined) return false;
    return true;
}

export function PrintTextResponseFromJSON(json: any): PrintTextResponse {
    return PrintTextResponseFromJSONTyped(json, false);
}

export function PrintTextResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrintTextResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceId': json['serviceId'],
    };
}

export function PrintTextResponseToJSON(json: any): PrintTextResponse {
    return PrintTextResponseToJSONTyped(json, false);
}

export function PrintTextResponseToJSONTyped(value?: PrintTextResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serviceId': value['serviceId'],
    };
}

